import { useQuery } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL, IFileDetailsAggregatorResponseDto } from '@/dtos';
import { FileStatus } from '@/modules/FileManager/FileManager.constants';
import { FileStatusPayload, getStatus } from '@/modules/FileManager/queries/useFilesList.query';
import { IFileTypeDtoFileTypeEnum } from '@/types';

export const GET_FILES_DETAILS_KEY = 'GET_FILES_DETAILS_KEY';


export interface FileDetails {
  id: string;

  createdAt: string;
  employers: string[];
  fileName: string;
  fileProcessingStatusType: FileStatus;
  fileType: IFileTypeDtoFileTypeEnum;
  partners: string[];
  processedAt: string;
  processedBy?: string;
  uploadWay: string;
  uploadedBy: string;

  createdRecordsCount: number;
  errorRecordsCount: number;
  noChangeRecordsCount: number;
  recordCounts: number;
  successfulRecordsCount: number;
  updatedRecordsCount: number;

  processingRecordsCount: number;
}

const formatData = (id: string, data: IFileDetailsAggregatorResponseDto): FileDetails => ({
  id,

  createdAt: (data?.file_aggregator_dto_response?.created_at || '') as unknown as string,
  employers: (data?.file_aggregator_dto_response?.employers || []) as string[],
  fileName: data?.file_aggregator_dto_response?.file_name || '',
  fileProcessingStatusType: getStatus(
    data?.file_aggregator_dto_response?.file_processing_status_type as unknown as FileStatusPayload
  ) as FileStatus,
  fileType: (data?.file_aggregator_dto_response?.file_type || '') as unknown as IFileTypeDtoFileTypeEnum,
  partners: (data?.file_aggregator_dto_response?.partners || []) as string[],
  processedAt: (data?.file_aggregator_dto_response?.processed_at || '') as string,
  processedBy: data?.file_aggregator_dto_response?.processed_by || '',
  uploadWay: data?.file_aggregator_dto_response?.upload_way || '',
  uploadedBy: data?.file_aggregator_dto_response?.uploaded_by || '',

  createdRecordsCount: data?.records_details_dto?.created_records_count || 0,
  errorRecordsCount: data?.records_details_dto?.error_records_count || 0,
  noChangeRecordsCount: data.records_details_dto?.no_change_records_count || 0,
  recordCounts: data?.records_details_dto?.record_counts || 0,
  successfulRecordsCount: data?.records_details_dto?.successful_records_count || 0,
  updatedRecordsCount: data?.records_details_dto?.updated_records_count || 0,
  processingRecordsCount: data?.records_details_dto?.processing_records_count || 0,
});

const useGetFileDetailsQuery = (id: string) => {
  const { isLoading, data, isSuccess, refetch, isRefetching } = useQuery([GET_FILES_DETAILS_KEY, id], () =>
    api.get(API_URL.FILE_FILES_DETAILS_BY_FILE_ID(id))
  );

  return {
    ...(data?.data ? { fileDetails: formatData(id, data.data) } : {}),
    isLoading,
    isSuccess,
    refetch,
    isRefetching,
  };
};

export default useGetFileDetailsQuery;
